const state = () => ({
  forms: [],
})

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
  SET_STATE_BY_INDEX(state, ops) {
    state[ops.key][ops.index][ops.subKey] = ops.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
